import { render, staticRenderFns } from "./VoucherDashboardPage.vue?vue&type=template&id=57247fba&scoped=true&"
import script from "./VoucherDashboardPage.vue?vue&type=script&lang=js&"
export * from "./VoucherDashboardPage.vue?vue&type=script&lang=js&"
import style0 from "./VoucherDashboardPage.vue?vue&type=style&index=0&id=57247fba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57247fba",
  null
  
)

export default component.exports